import styled from 'styled-components'

const settingHeight = {
  mobile: '120px',
  desktop: '140px',
}

export const BannerContainer = styled.div`
  background-image: url(${({ image }) => image});
  background-position: ${({ position }) => position};
  background-size: cover;
  height: ${settingHeight.mobile};
  width: 100%;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    height: ${settingHeight.desktop};
  }
`
export const BannerWrapperText = styled.div`
  height: ${settingHeight.mobile};
  color: white;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    height: ${settingHeight.desktop};
  }
`
export const Title = styled.p`
  font-size: 24px;
  line-height: 32px;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 32px;
    line-height: 40px;
  }
`
export const SubTitle = styled.h1`
  font-size: 18px;
  line-height: 24px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 24px;
    line-height: 32px;
  }
`
export const Total = styled.span``
